import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DateTime} from 'luxon';

import {SharedFacadeService} from '@shared/shared-facade.service';
import {AgendaActivity} from '@model/agenda-activity';
import {Schedule} from '@model/schedule';
import {Study} from '@model/study';
import {StaffMemberAbsenceWithDetails} from '@model/staff-member-absence';
import {Profile} from '@model/profile';
import {PublicMessage} from '@model/public-message';

@Injectable()
export class ValveFacadeService {
  profile$: Observable<Profile>;
  agendaActivities$: Observable<AgendaActivity[]>;
  schedule$: Observable<Schedule>;
  staffMemberAbsenceStudies$: Observable<Study[]>;
  staffMemberAbsencesWithDetails$: Observable<StaffMemberAbsenceWithDetails[]>;
  publicMessage$: Observable<PublicMessage>;

  constructor(private _sharedFacade: SharedFacadeService) {
    this.profile$ = this._sharedFacade.profile$;
    this.agendaActivities$ = this._sharedFacade.agendaActivities$;
    this.schedule$ = this._sharedFacade.schedule$;
    this.staffMemberAbsenceStudies$ = this._sharedFacade.staffMemberAbsenceStudies$;
    this.staffMemberAbsencesWithDetails$ = this._sharedFacade.staffMemberAbsencesWithDetails$;
    this.publicMessage$ = this._sharedFacade.publicMessage$;
  }

  loadStaffMembers() {
    this._sharedFacade.loadStaffMembers();
  }

  loadAgendaActivities() {
    this._sharedFacade.loadAgendaActivities();
  }

  loadSchedule() {
    this._sharedFacade.loadSchedule();
  }

  loadStaffMemberAbsenceStudy(date: DateTime) {
    this._sharedFacade.loadStaffMemberAbsenceStudy(date);
  }

  loadStaffMemberAbsence(date: DateTime) {
    this._sharedFacade.loadStaffMemberAbsence(date);
  }

  loadResources() {
    this._sharedFacade.loadResources();
  }

  loadPublicMessage() {
    this._sharedFacade.loadPublicMessage();
  }
}
